module.exports = __webpack_public_path__ + "img/chairs-accomodation.d767d988.webp";